import { render, staticRenderFns } from "./cDocumentTraining.vue?vue&type=template&id=dd9f9126&scoped=true"
import script from "./cDocumentTraining.vue?vue&type=script&lang=js"
export * from "./cDocumentTraining.vue?vue&type=script&lang=js"
import style0 from "./cDocumentTraining.vue?vue&type=style&index=0&id=dd9f9126&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9f9126",
  null
  
)

export default component.exports